!function (a, n) {
  "object" == typeof exports && "undefined" != typeof module ? module.exports = n() : "function" == typeof define && define.amd ? define(n) : (a.ReactIntlLocaleData = a.ReactIntlLocaleData || {}, a.ReactIntlLocaleData.fil = n());
}(this, function () {
  "use strict";

  return [{
    locale: "fil",
    pluralRuleFunction: function (a, n) {
      var e = String(a).split("."),
        o = e[0],
        t = e[1] || "",
        s = !e[1],
        r = o.slice(-1),
        i = t.slice(-1);
      return n ? 1 == a ? "one" : "other" : s && (1 == o || 2 == o || 3 == o) || s && 4 != r && 6 != r && 9 != r || !s && 4 != i && 6 != i && 9 != i ? "one" : "other";
    },
    fields: {
      year: {
        displayName: "taon",
        relative: {
          0: "ngayong taon",
          1: "susunod na taon",
          "-1": "nakaraang taon"
        },
        relativeTime: {
          future: {
            one: "sa {0} taon",
            other: "sa {0} (na) taon"
          },
          past: {
            one: "{0} taon ang nakalipas",
            other: "{0} (na) taon ang nakalipas"
          }
        }
      },
      "year-short": {
        displayName: "taon",
        relative: {
          0: "ngayong taon",
          1: "susunod na taon",
          "-1": "nakaraang taon"
        },
        relativeTime: {
          future: {
            one: "sa {0} taon",
            other: "sa {0} (na) taon"
          },
          past: {
            one: "{0} taon ang nakalipas",
            other: "{0} (na) taon ang nakalipas"
          }
        }
      },
      month: {
        displayName: "buwan",
        relative: {
          0: "ngayong buwan",
          1: "susunod na buwan",
          "-1": "nakaraang buwan"
        },
        relativeTime: {
          future: {
            one: "sa {0} buwan",
            other: "sa {0} (na) buwan"
          },
          past: {
            one: "{0} buwan ang nakalipas",
            other: "{0} (na) buwan ang nakalipas"
          }
        }
      },
      "month-short": {
        displayName: "buwan",
        relative: {
          0: "ngayong buwan",
          1: "susunod na buwan",
          "-1": "nakaraang buwan"
        },
        relativeTime: {
          future: {
            one: "sa {0} buwan",
            other: "sa {0} (na) buwan"
          },
          past: {
            one: "{0} buwan ang nakalipas",
            other: "{0} (na) buwan ang nakalipas"
          }
        }
      },
      day: {
        displayName: "araw",
        relative: {
          0: "ngayong araw",
          1: "bukas",
          2: "Samakalawa",
          "-2": "Araw bago ang kahapon",
          "-1": "kahapon"
        },
        relativeTime: {
          future: {
            one: "sa {0} araw",
            other: "sa {0} (na) araw"
          },
          past: {
            one: "{0} araw ang nakalipas",
            other: "{0} (na) araw ang nakalipas"
          }
        }
      },
      "day-short": {
        displayName: "araw",
        relative: {
          0: "ngayong araw",
          1: "bukas",
          2: "Samakalawa",
          "-2": "Araw bago ang kahapon",
          "-1": "kahapon"
        },
        relativeTime: {
          future: {
            one: "sa {0} (na) araw",
            other: "sa {0} (na) araw"
          },
          past: {
            one: "{0} (na) araw ang nakalipas",
            other: "{0} (na) araw ang nakalipas"
          }
        }
      },
      hour: {
        displayName: "oras",
        relative: {
          0: "ngayong oras"
        },
        relativeTime: {
          future: {
            one: "sa {0} oras",
            other: "sa {0} (na) oras"
          },
          past: {
            one: "{0} oras ang nakalipas",
            other: "{0} (na) oras ang nakalipas"
          }
        }
      },
      "hour-short": {
        displayName: "oras",
        relative: {
          0: "ngayong oras"
        },
        relativeTime: {
          future: {
            one: "sa {0} oras",
            other: "sa {0} (na) oras"
          },
          past: {
            one: "{0} oras ang nakalipas",
            other: "{0} (na) oras ang nakalipas"
          }
        }
      },
      minute: {
        displayName: "minuto",
        relative: {
          0: "sa minutong ito"
        },
        relativeTime: {
          future: {
            one: "sa {0} minuto",
            other: "sa {0} (na) minuto"
          },
          past: {
            one: "{0} minuto ang nakalipas",
            other: "{0} (na) minuto ang nakalipas"
          }
        }
      },
      "minute-short": {
        displayName: "min.",
        relative: {
          0: "sa minutong ito"
        },
        relativeTime: {
          future: {
            one: "sa {0} min.",
            other: "sa {0} (na) min."
          },
          past: {
            one: "{0} min. ang nakalipas",
            other: "{0} (na) min. ang nakalipas"
          }
        }
      },
      second: {
        displayName: "segundo",
        relative: {
          0: "ngayon"
        },
        relativeTime: {
          future: {
            one: "sa {0} segundo",
            other: "sa {0} (na) segundo"
          },
          past: {
            one: "{0} segundo ang nakalipas",
            other: "{0} (na) segundo ang nakalipas"
          }
        }
      },
      "second-short": {
        displayName: "seg.",
        relative: {
          0: "ngayon"
        },
        relativeTime: {
          future: {
            one: "sa {0} seg.",
            other: "sa {0} (na) seg."
          },
          past: {
            one: "{0} seg. ang nakalipas",
            other: "{0} (na) seg. nakalipas"
          }
        }
      }
    }
  }];
});